// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IVqa","largestCol":"styles_largestCol__3Zzvz","smallestCol":"styles_smallestCol__MaoIT"};